module.exports = __webpack_public_path__ + "img/logo_paysoon-rgb.89302b44.png";